import React from "react";
import { PricePageRecurringInputModel } from "../models";
import { DescriptionCell, getOptions, LabelCell } from "../styles";
import {
  CustomLabel,
  FlexContainer,
  InfoIcon,
  Input,
  SingleSelect,
} from "@mindmemobile/mm-shared-global";

type FeeSectionProps = {
  feeInterval: string;
  fee: string;
  className?: string;
  recurringSelect?: string;
  onFeeIntervalChange: (value: string) => void;
  onFeeChange: (value: string, isBlur?: boolean) => void;
  fieldname: keyof PricePageRecurringInputModel;
  hasError: (fieldName: string) => boolean;
  disableRecurringSelect?: boolean;
  errorMessage?: string;
};

export const RecurringFeeSection: React.FC<FeeSectionProps> = ({
  feeInterval,
  fee,
  onFeeIntervalChange,
  onFeeChange,
  fieldname,
  hasError,
  className,
  recurringSelect,
  disableRecurringSelect,
  errorMessage,
}) => {
  const feeIntervalElement = (
    <SingleSelect
      selectedKey={feeInterval}
      nameKeys={["label"]}
      valueKeys={["value"]}
      options={[getOptions(fieldname)]}
      onChange={(option) =>
        !disableRecurringSelect && onFeeIntervalChange(option.value)
      }
      hasError={hasError("feeInterval") || hasError("recurringFeeInterval")}
      className={`dpdn-no-separator price-increase-interval ${recurringSelect}`}
      disabled={disableRecurringSelect}
      errorMessage={errorMessage}
    />
  );

  return (
    <FlexContainer className={`label-description-row ${className}`}>
      <LabelCell>
        <CustomLabel lineHeight="40px" fontSize="16px">
          Additional Fee
        </CustomLabel>
        <InfoIcon />
      </LabelCell>
      <DescriptionCell>
        <FlexContainer spacing={15} fxWrap="wrap">
          {feeInterval === "None" ? (
            feeIntervalElement
          ) : (
            <>
              {feeIntervalElement}
              <FlexContainer spacing={15} className="dollar-usd-input usd-with-error usd-impact-right">
                <Input
                  value={fee}
                  type="text"
                  error={hasError("fee") || hasError("recurringFee")}
                  className="styled-input number-selector"
                  onChange={(e, isBlur) => onFeeChange(e.target.value, isBlur)}
                  placeholder="0.00"
                  errorMessage={errorMessage}
                />
              </FlexContainer>
            </>
          )}
        </FlexContainer>
      </DescriptionCell>
    </FlexContainer>
  );
};

export default RecurringFeeSection;
